export default "__VITE_ASSET__2a227500__"